import { Component, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BreadcrumbModel, BreadcrumbTheme } from './breadcrumb.interface';
import { BreadcrumbService } from './breadcrumb.service';
import { EllipsesService } from './ellipses.service';
@Component({
  selector: 'vm-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [BreadcrumbService, EllipsesService],
})
export class BreadcrumbComponent implements OnInit {
  @Input() breadcrumbNumber: number;

  @Input() breadcrumbs: BreadcrumbModel[];
  @Input() homePage: string;
  @Input() theme: BreadcrumbTheme = BreadcrumbTheme.LIGHT;

  displayedCrumbs: BreadcrumbModel[] = [];

  lightThemeSelected = true;

  constructor(private breadcrumbService: BreadcrumbService, private ellipsesService: EllipsesService) {}

  currentPage: string;

  ngOnInit() {
    this.ellipsesService.createBreadCrumbElementsForHeightReference();
    this.lightThemeSelected = this.theme === BreadcrumbTheme.LIGHT;
    this.displayedCrumbs = this.ellipsesService.generateEllipses(this.breadcrumbs);
    this.displayedCrumbs = this.breadcrumbService.processBreadcrumbsForDisplay(
      this.displayedCrumbs,
      this.breadcrumbNumber
    );
  }

  @HostListener('window:resize')
  onResize() {
    this.ellipsesService.createBreadCrumbElementsForHeightReference();
    this.displayedCrumbs = this.ellipsesService.generateEllipses(this.breadcrumbs);
    this.displayedCrumbs = this.breadcrumbService.processBreadcrumbsForDisplay(
      this.displayedCrumbs,
      this.breadcrumbNumber
    );
  }
}
